import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card"
import { Separator } from "@/components/ui/separator"
import type { Milestone } from "@/services/api/cronos/tracking/students/get-situation"
import { format } from "date-fns"
import { es } from "date-fns/locale"

interface MilestoneListProps {
  milestones: Milestone[]
}

export default function MilestoneList({ milestones }: MilestoneListProps) {
  return (
    <Card className="h-fit border-none shadow-sm">
      <CardHeader>
        <CardTitle className="text-sm font-bold text-foreground">
          Hitos importantes de mi materia
        </CardTitle>
      </CardHeader>
      <CardContent>
        {milestones.length === 0 ? (
          <div className="flex flex-col gap-2">
            <CardDescription className="text-sm text-muted-foreground">
              No hay hitos importantes de mi materia
            </CardDescription>
          </div>
        ) : (
          <div className="flex flex-col gap-2">
            {milestones.map((milestone) => (
              <div key={milestone.title} className="flex items-center gap-4">
                <div className="flex flex-col items-center gap-1">
                  <span className="text-xs font-medium uppercase text-primary-500">
                    {format(milestone.dateTime, "MMM", {
                      locale: es,
                    })}
                  </span>
                  <span className="font-regular text-lg">{format(milestone.dateTime, "d")}</span>
                </div>
                <Separator className="h-11 w-px bg-primary-400" orientation="vertical" />
                <div className="flex flex-col gap-1">
                  <span className="text-sm font-medium">{milestone.title}</span>
                  {milestone.modules?.length && (
                    <>
                      <span className="text-xs text-muted-foreground">
                        {milestone.modules.length > 1 ? "Módulos" : "Módulo"}:{" "}
                        {milestone.modules.join(", ")}
                      </span>
                    </>
                  )}
                </div>
              </div>
            ))}
          </div>
        )}
      </CardContent>
    </Card>
  )
}
